import * as Yup from 'yup';
import { sharedTestSchemaValidation } from './RunTestSharedSchema';
import { Test } from './RunTest';

export interface ValidationError {
  value?: any;
  message: string;
}

export const ValidateImportedTests = async (importedTests: Test[], isSuperAdmin: boolean) => {
  const validationSchema = Yup.array().of(sharedTestSchemaValidation(isSuperAdmin));

  try {
    await validationSchema.validate(importedTests, { abortEarly: false });
  } catch (validationError) {
    if (validationError instanceof Yup.ValidationError) {
      const errors: ValidationError[] = (validationError as Yup.ValidationError).inner.map(
        (err: Yup.ValidationError) => ({
          message: err.message,
          value: err.value
        })
      );
      throw errors;
    } else {
      console.error('Unexpected validation error:', validationError);
      const error = {
        message: 'Unexpected validation error.',
        value: 'N/A'
      };
      throw error;
    }
  }

  return importedTests;
};
